import { Injectable, OnDestroy } from '@angular/core'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'
import { tap } from 'rxjs/operators'
import { Subscription } from 'rxjs'

@Injectable()
export class CustomPageTitleStrategy extends TitleStrategy implements OnDestroy {
  private subscriptions = new Subscription()
  constructor(
    private translateService: TranslateService,
    private readonly title: Title,
  ) {
    super()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(this.translateService.instant(snapshot.root.firstChild.data?.title))
    this.subscriptions.add(
      this.translateService.onLangChange
        .pipe(
          tap(x => {
            this.title.setTitle(this.translateService.instant(snapshot.root.firstChild.data?.title))
          }),
        )
        .subscribe(),
    )
  }
}
